module.exports = __webpack_public_path__ + "static/media/remove-format.140e4f29.svg";